import React from "react";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function StyledDropdown({
  values = [],
  selectedValue,
  setSelectedValue,
  placeholder = "Select option...",
  disabled = false,
  className = "",
  dataIndex,
}) {
  const displayValue = selectedValue || placeholder;

  return (
    <div className={className}>
      <Menu as="div" className="relative w-full">
        <div>
          <Menu.Button
            disabled={disabled}
            className={classNames(
              "relative h-7 min-h-7 w-full rounded-md border border-edge-input bg-white",
              "px-2 text-left text-sm leading-tight text-ink",
              "hover:border-edge-input focus:outline-none focus:ring-2 focus:ring-sage focus:border-sage",
              "flex cursor-default items-center justify-between",
              disabled ? "cursor-not-allowed opacity-50" : "",
              selectedValue ? "text-ink" : "text-ink-muted"
            )}
          >
            <span className="block truncate">{displayValue}</span>
            <ChevronDownIcon
              className="h-4 w-4 text-ink-muted"
              aria-hidden="true"
            />
          </Menu.Button>
        </div>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute z-10 mt-1 w-full rounded-md border border-edge bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
            <div className="py-1">
              {values.map((value, index) => {
                return (
                  <Menu.Item key={value || index}>
                    {({ active }) => (
                      <button
                        type="button"
                        data-value={value}
                        data-index={
                          dataIndex !== undefined ? dataIndex : undefined
                        }
                        onClick={(e) => {
                          // using regular dropdown
                          if (dataIndex === undefined) {
                            setSelectedValue(value);
                          }
                          // using data attributes
                          else {
                            setSelectedValue(e);
                          }
                        }}
                        className={classNames(
                          "w-full px-3 py-2 text-left text-sm",
                          active
                            ? "bg-paper-inset text-ink"
                            : "text-ink-secondary",
                          value === selectedValue
                            ? "bg-ink-secondary text-white"
                            : ""
                        )}
                      >
                        {value}
                      </button>
                    )}
                  </Menu.Item>
                );
              })}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
